/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
function fixSlideshowOverflow() {
  document.querySelectorAll('.slideshow__slide')
    .forEach(slide => {
      slide.classList.remove('js-overflow-container');
      slide.style.removeProperty('min-height');
    });
}

document.addEventListener('DOMContentLoaded', fixSlideshowOverflow);
document.addEventListener('theme:resize', fixSlideshowOverflow);
document.addEventListener('shopify:section:load', fixSlideshowOverflow);
